import { useState, Fragment } from "react";
import { IRDoc } from "../../models/Doc";
import ChevronDownIcon from "@/v2-components/core/icon/chevron-down-icon";
import ChevronUpIcon from "@/v2-components/core/icon/chevron-up-icon";
import WordpressStyleDiv from "../WordpressStyleDiv";
import DOMPurify from "dompurify";

type Props = { filteredData: IRDoc[] };
const IrDocList = ({ filteredData }: Props) => {
  const [select, setSelect] = useState<string>("");

  return (
    <Fragment>
      <div className={"h-full border-t"}>
        {filteredData.map((ir: IRDoc, index) => {
          const publishedDate = Object.keys(ir.tags)[0];
          const open = select === ir.ID;
          return (
            <div
              className={
                "flex flex-col items-center justify-center border-b py-4"
              }
              key={index}
            >
              <div
                className={"flex w-full cursor-pointer place-content-between"}
                onClick={async () => {
                  if (select === ir.ID) {
                    setSelect("");
                  } else {
                    setSelect(ir.ID);
                  }
                }}
              >
                <div
                  className={
                    "line-clamp-2 truncate whitespace-pre-wrap pr-2 text-lg font-700"
                  }
                >
                  {ir.title}
                </div>
                <div className={"flex min-w-fit gap-x-3"}>
                  <div>{publishedDate}</div>
                  <div>{open ? <ChevronUpIcon /> : <ChevronDownIcon />}</div>
                </div>
              </div>
              {open && (
                <div
                  className={
                    "mt-4 flex w-full flex-col items-start justify-start gap-y-6"
                  }
                >
                  <WordpressStyleDiv className="entry-content wp-block-post-content is-layout-constrained wp-block-post-content-is-layout-constrained [&_p]:min-h-4">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(ir.content),
                      }}
                    />
                  </WordpressStyleDiv>
                </div>
              )}
            </div>
          );
        })}
      </div>
    </Fragment>
  );
};
export default IrDocList;
